import type { AppLocale, TranslationTree } from '../locale.model';
import { authPtBr, commonPtBr, dashboardPtBr, navPtBr } from './pt-BR';
import { authEn, commonEn, dashboardEn, navEn } from './en';
import { authEsEs, commonEsEs, dashboardEsEs, navEsEs } from './es-ES';
import { pagesPtBr } from './pages/pt-BR';
import { pagesEn } from './pages/en';
import { pagesEsEs } from './pages/es-ES';

function merge(...trees: TranslationTree[]): TranslationTree {
  return Object.assign({}, ...trees);
}

export const TRANSLATIONS: Record<AppLocale, TranslationTree> = {
  'pt-BR': merge(
    { common: commonPtBr, auth: authPtBr, nav: navPtBr, dashboard: dashboardPtBr },
    pagesPtBr,
  ),
  en: merge({ common: commonEn, auth: authEn, nav: navEn, dashboard: dashboardEn }, pagesEn),
  'es-ES': merge(
    { common: commonEsEs, auth: authEsEs, nav: navEsEs, dashboard: dashboardEsEs },
    pagesEsEs,
  ),
};
